import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function PrintGiftCardIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 60.8 65.16">
      <path d="M57.6 0H21.4a3.2 3.2 0 00-3.2 3.2v27.91a.8.8 0 001.6 0V3.2a1.6 1.6 0 011.6-1.6h36.2a1.6 1.6 0 011.6 1.6v48.2a1.6 1.6 0 01-1.6 1.6H37.8a.8.8 0 000 1.6h19.8a3.21 3.21 0 003.2-3.2V3.2A3.21 3.21 0 0057.6 0z"/>
      <path d="M48.13 29.75c.17 0 .31-.43.31-1s-.14-1-.31-1h-9.82c-.17 0-.31.44-.31 1s.14 1 .31 1zm-9.62 5h16.41c.29 0 .52-.43.52-1s-.23-1-.52-1H38.51c-.28 0-.51.44-.51 1s.23 1 .51 1zM50.5 4.8A5.5 5.5 0 0046 7.14a5.5 5.5 0 10-4.5 8.66h1.17l-4.41 4.46a.91.91 0 000 1.28.89.89 0 001.26 0l5.66-5.74h1.64l5.66 5.74a.89.89 0 001.26 0 .91.91 0 000-1.28l-4.41-4.46h1.17a5.5 5.5 0 000-11zM45 10.3v3.14l-.52.53h-3a3.67 3.67 0 113.57-4.49 5.55 5.55 0 00-.05.82zm5.5 3.7h-3l-.5-.56V10.3a5.55 5.55 0 00-.07-.82A3.67 3.67 0 1150.5 14zM30.79 47a1 1 0 10-1-1 1 1 0 001 1z"/>
      <path d="M10.75 54.08h14.18v2.07H10.75zm0 4.13h14.18v2.07H10.75z"/>
      <path d="M31.16 37.33a3.06 3.06 0 00-3-3.1H7.55a3.07 3.07 0 00-3 3.1v4.16H0v16.09h5.86v7.58h24v-7.58h5.87V41.49h-4.57zm-24.62 0a1 1 0 011-1h20.59a1 1 0 011 1v4.16H6.54zm21.25 25.76H7.88V51.25h19.91zm5.87-19.54v12h-3.85v-6.36H5.86v6.32H2v-12z"/>
    </SvgIcon>
  )
}
export default PrintGiftCardIcon
